import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-grid-system";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import {
  updateProductFields,
  updateProductStatus,
  AddProductToCategory,
  archiveProduct,
} from "../../../server/Product";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input, { Select } from "../../containers/InputForm";
import ProductEditPerloed from "./productEditPerloed";
import {
  LinkedProducts,
  LinkedProductsRemove,
} from "../../../server/LinkedProducts";
import { getDictByKind } from "../../../server/Category";
import * as actionType from "../../../store/action";
import { showAlertWithConfirmCancel } from "../../../server/ShowAlert";
import { useNavigate } from "react-router-dom";

const schema = yup
  .object({
    name: yup.string().required("שם המוצר חובה"),
    gtin: yup
      .string()
      .required("חובה להכניס ברקוד")
      .test("len", (x) => x.length >= 5 && x.length <= 15),
    description: yup.string().max(35, "תיאור חייב להיות עד 35 תווים"),
  })
  .required();

const ProductEditForm = ({ setPendingScrollSlug }) => {
  const [catsOptions, setCatsOptions] = useState([]);
  const [alterProds, setAlterProds] = useState([]);
  const [parallelProds, setParallelProds] = useState([]);
  const [parentCategory, setParentCategory] = useState(null);
  const [_brand, setBrand] = useState([]);
  const [subBrand, setSubBrand] = useState([]);
  const [kashrut, setKashrut] = useState([]);
  const [statusMessage, setStatusMessage] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { categoriesState, product, products, stationId, productCategories } =
    useSelector((state) => ({
      categoriesState: state.category.categories,
      product: state.selectedProduct.product,
      products: state.selectedProduct.products,
      stationId: state.user.stationId,
      productCategories: state.selectedProduct.productCategories,
    }));

  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues: { ...product },
    resolver: yupResolver(schema),
  });

  const kashrutTypeOptions = [
    { Id: "חלבי", Name: "חלבי" },
    { Id: "בשרי", Name: "בשרי" },
    { Id: "פרווה", Name: "פרווה" },
    { Id: "לא מוגדר", Name: "לא מוגדר" },
  ];

  const kashrutFeatureOptions = [
    { Id: "כשרות לימות השנה", Name: "כשרות לימות השנה" },
    { Id: "כשר לפסח", Name: "כשר לפסח" },
    { Id: "כשר לפסח לאוכלי קטניות", Name: "כשר לפסח לאוכלי קטניות" },
    { Id: "כשרות", Name: "כשרות" },
    { Id: "מאושר", Name: "מאושר" },
    { Id: "מאושר לפסח", Name: "מאושר לפסח" },
    { Id: "נאפה לאחר הפסח", Name: "נאפה לאחר הפסח" },
    { Id: "נטחן ונאפה לאחר פסח", Name: "נטחן ונאפה לאחר פסח" },
    { Id: "מקמח שנטחן לאחר פסח", Name: "מקמח שנטחן לאחר פסח" },
    { Id: "-", Name: "-" },
  ];

  const unitOfMeasureOptions = [
    { Id: "גרם", Name: "גרם" },
    { Id: "יחידה", Name: "יחידה" },
    { Id: "יחידות", Name: "יחידות" },
    { Id: "ליטר", Name: "ליטר" },
    { Id: 'מ"ל', Name: 'מ"ל' },
    { Id: "מטר", Name: "מטר" },
    { Id: 'ק"ג', Name: 'ק"ג' },
  ];

  const statusOptions = [
    { Id: "ACTIVE", Name: "פעיל" },
    { Id: "INACTIVE", Name: "לא פעיל" },
  ];

  useEffect(() => {
    if (subBrand.length && product?.subBrand?.id)
      setValue("subBrand", product.subBrand?.id);
    if (
      kashrut.length &&
      product?.kosherSupervision?.[0]?.supervisionAgency?.id
    )
      setValue(
        "kashrut",
        product.kosherSupervision?.[0]?.supervisionAgency?.id,
      );
  }, [product, subBrand, kashrut, setValue]);

  useEffect(() => {
    if (product) {
      setIsInitialized(false);
      reset({
        ...product,
        status: productCategories?.[0]?.productStatus || "",
      });
    }
  }, [product, reset]);

  useEffect(() => {
    //dispatch(getAllCategory(678430, productCategories?.at(-1)?.slug || null, 5, true, true));
    const fetchFromDict = (kind, setKind) => {
      getDictByKind(kind)
        .then((res) => setKind(res))
        .catch((error) => console.error("Error fetching dictionary:", error));
    };
    fetchFromDict("sub-brand", setSubBrand);
    fetchFromDict("kashrut", setKashrut);
    fetchFromDict("brand", setBrand);
  }, []);

  const showArchiveMessage = (type, text) => {
    setStatusMessage({ type, text });

    setTimeout(() => {
      setStatusMessage(null);
    }, 3000);
  };

  const archiveCurrentProduct = () => {
    if (!product?.productId) return;

    showAlertWithConfirmCancel({
      msgTitle: "האם להעביר את המוצר לארכיון?",
      confirmText: "אישור",
      cancelText: "ביטול",

      onConfirm: async () => {
        try {
          await archiveProduct(product.productId, stationId);

          showArchiveMessage("success", "המוצר הועבר לארכיון בהצלחה");

          setTimeout(() => {
            const hierarchy = productCategories?.[0]?.categoryHierarchy ?? [];
            const reversedNav = [...hierarchy].reverse();

            if (reversedNav.length > 0) {
              const firstCategory = reversedNav[0];

              if (reversedNav.length > 1) {
                const secondCategory = reversedNav.at(-1);
                setPendingScrollSlug?.(secondCategory.slug);
              }

              navigate(`/category/${firstCategory.slug}`);
            } else {
              navigate("/");
            }
          }, 900);
        } catch (error) {
          console.error("Archive product failed:", error);

          showArchiveMessage("error", "אירעה שגיאה בהעברת המוצר לארכיון");
        }
      },
    });
  };

  const handleStatusChange = async (e) => {
    if (!product) return;

    const status = e.target.value;
    const hierarchy = productCategories?.[0]?.categoryHierarchy ?? [];
    const lastCategory = hierarchy[0];

    try {
      const res = await updateProductStatus(
        product.productId,
        lastCategory?.slug || null,
        status,
        stationId,
      );

      if (res?.status === 200) {
        setStatusMessage({ type: "success", text: "הסטטוס עודכן בהצלחה" });

        setTimeout(() => {
          setStatusMessage(null);
        }, 3000);
      } else {
        setStatusMessage({ type: "error", text: "אירעה שגיאה בעדכון הסטטוס" });

        setTimeout(() => {
          setStatusMessage(null);
        }, 3000);
      }
    } catch {
      setStatusMessage({ type: "error", text: "אירעה שגיאה בעדכון הסטטוס" });

      setTimeout(() => {
        setStatusMessage(null);
      }, 3000);
    }
  };

  const selectProductLink = (currProd, chosenProd, action) => {
    const val = {
      ProductMkt: currProd,
      SubProductMkt: chosenProd,
      TypeLinked: action,
    };
    LinkedProducts(val)
      .then(() => {
        const match = products.find((prods) => prods.Mkt === chosenProd);
        switch (action) {
          case "1":
            const alterProdsEdit = [...alterProds];
            alterProdsEdit.push(match);
            setAlterProds(alterProdsEdit);
            break;
          case "2":
            const parallelProdsEdit = [...parallelProds];
            parallelProdsEdit.push(match);
            setParallelProds(parallelProdsEdit);
            break;
          default:
            break;
        }
      })
      .catch(() => console.log("error"));
  };

  const removeLinkage = (ProductMkt, SubProductMkt, TypeLinked) => {
    const val = { TypeLinked, ProductMkt, SubProductMkt };
    LinkedProductsRemove(val)
      .then(() => {
        if (TypeLinked === "1") {
          const nextAlter = alterProds.filter(
            (item) => item.ProductMkt !== ProductMkt,
          );
          setAlterProds(nextAlter);
        } else if (TypeLinked === "2") {
          const nextParallel = parallelProds.filter(
            (item) => item.ProductMkt !== ProductMkt,
          );
          setParallelProds(nextParallel);
        }
      })
      .catch(() => console.log("error"));
  };

  const buildKosherSupervision = (overrides = {}) => {
    const existing = product?.kosherSupervision?.[0] ?? {};
    return [{ ...existing, ...overrides }];
  };

  const tryUpdate = ({ target: { id, type, value, checked } }) => {
    handleSubmit();
    if (!errors[id]) {
      let change;
      switch (id) {
        case "kashrut":
          change = {
            kosherSupervision: buildKosherSupervision({
              supervisionAgency: (({ id, name, img, tenantKind }) => ({
                id,
                name,
                img,
                tenantKind,
              }))(kashrut.find((item) => item.id === value) || {}),
            }),
          };
          break;
        case "subBrand":
          change = {
            subBrand: (({ id, name }) => ({ id, name }))(
              subBrand.find((item) => item.id === value),
            ),
          };
          break;
        case "kosherSupervision[0].kashrutFeature":
          change = {
            kosherSupervision: buildKosherSupervision({
              kashrutFeature: value,
            }),
          };
          break;
        case "kosherSupervision[0].classification":
          change = {
            kosherSupervision: buildKosherSupervision({
              classification: value,
            }),
          };
          break;
        default:
          change = { [id]: type === "checkbox" ? checked : value };
          break;
      }
      updateProductFields(stationId, product.productId, change);
    }
  };

  useEffect(() => {
    if (isInitialized) return;

    if (categoriesState.length > 0) {
      const hierarchy = productCategories?.[0]?.categoryHierarchy || [];
      setParentCategory(hierarchy[0]?.slug);

      const newCatsOptions = [];
      newCatsOptions.push(categoriesState);

      if (hierarchy?.length > 0) {
        [...hierarchy].reverse().forEach((cat, index) => {
          setValue(`catLevel${index + 1}`, cat.slug);

          const parentLevel = newCatsOptions.at(-1);
          const found = parentLevel?.find(
            (category) => category.slug === cat.slug,
          );
          found?.children.length > 0 && newCatsOptions.push(found.children);
        });

        if (hierarchy[0]?.isFamily && hierarchy.length < 4) {
          setValue(`catLevel4`, hierarchy[0].slug);
          newCatsOptions.splice(newCatsOptions.length - 1, 0, []);
        }
      }

      setCatsOptions(newCatsOptions);
      setIsInitialized(true);
    }
  }, [productCategories, categoriesState]);

  const tryUpdateCategory = ({ target: { id, value } }) => {
    handleSubmit();
    if (!errors[id]) {
      const level = parseInt(id.split("catLevel")[1]);

      // value === "" means this level is cleared — parent is one level up
      const effectiveValue =
        value === ""
          ? productCategories?.[0]?.categoryHierarchy.find(
              (c) => c.slug === watch(`catLevel${level}`),
            )?.parentSlug
          : value;

      if (!parentCategory) {
        dispatch(
          AddProductToCategory(effectiveValue, product.productId, stationId),
        );
      } else {
        updateProductFields(stationId, product.productId, {
          fromSlug: parentCategory,
          toSlug: effectiveValue,
        })
          .then((res) => {
            setValue(`catLevel${level}`, value);

            if (value === "") {
              const newCatsOptions = [...catsOptions.slice(0, level)];
              setCatsOptions(newCatsOptions);
              for (let i = level; i <= catsOptions.length; i++) {
                setValue(`catLevel${i}`, null);
              }
              const index = productCategories[0]?.categoryHierarchy.findIndex(
                (c) => c.slug === parentCategory,
              );
              dispatch({
                type: actionType.SET_PRODUCT_CATEGORIES,
                data: [
                  {
                    categoryHierarchy:
                      index !== -1
                        ? productCategories[0]?.categoryHierarchy.slice(
                            index + 1,
                          )
                        : [],
                  },
                ],
              });
            } else {
              const newCatsOptions = [...catsOptions.slice(0, level)];
              const lastLevelOptions =
                newCatsOptions[level - 1].length > 0
                  ? newCatsOptions[level - 1]
                  : newCatsOptions[level - 2];
              newCatsOptions[level] = lastLevelOptions.find(
                (cat) => cat.slug === value,
              ).children;
              setCatsOptions(newCatsOptions);
              setValue(`catLevel${level + 1}`, null);
              const isAdded =
                productCategories[0]?.categoryHierarchy[0].slug ===
                parentCategory;
              const newCat = [{ slug: value, parentSlug: parentCategory }];
              dispatch({
                type: actionType.SET_PRODUCT_CATEGORIES,
                data: [
                  {
                    categoryHierarchy: isAdded
                      ? newCat.concat(productCategories[0].categoryHierarchy)
                      : newCat.concat(
                          productCategories[0]?.categoryHierarchy.slice(
                            productCategories[0]?.categoryHierarchy.findIndex(
                              (c) => c.slug === value,
                            ) + 1,
                          ),
                        ),
                  },
                ],
              });
            }
            setParentCategory(effectiveValue);
          })
          .catch((e) => console.log("error", e));
      }
    }
  };

  return (
    <form className="product-details-edit">
      {statusMessage && (
        <div
          style={{
            padding: "10px",
            marginBottom: "10px",
            borderRadius: "6px",
            backgroundColor:
              statusMessage.type === "success"
                ? "var(--color-accent-green, var(--c-accent-green))"
                : "var(--color-danger-surface, var(--c-danger-surface))" /* TODO: danger-surface not in tokens */,
            color:
              statusMessage.type === "success"
                ? "var(--color-accent-green-text, var(--c-accent-green-text))"
                : "var(--color-danger, var(--c-danger))",
          }}
        >
          {statusMessage.text}
        </div>
      )}
      <Container>
        <Row>
          <InputCol
            sm={4}
            name="name"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="textarea"
            label="שם המוצר"
          />
          <InputCol
            sm={2}
            name="gtin"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            label="ברקוד"
            type="text"
          />
          <InputCol
            sm={2}
            name="SubMkt"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="מקט יצרן"
          />
          <Col sm={4}>
            <div className="status-and-archive">
              <div style={{ flex: 1 }}>
                <Select
                  name="status"
                  errors={errors}
                  register={register}
                  options={statusOptions}
                  label="סטטוס"
                  onChange={handleStatusChange}
                  value={watch("status")}
                  clearable={false}
                />
              </div>

              <button
                type="button"
                onClick={archiveCurrentProduct}
                className="archive-product-btn"
              >
                העבר לארכיון
              </button>
            </div>
          </Col>
        </Row>

        <Row>
          <InputCol
            sm={4}
            name="description"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="textarea"
            label="תיאור קצר"
          />
          <SelectCol
            sm={4}
            name="kashrut"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={kashrut}
            label="כשרות"
            value={watch("kashrut")}
          />
          {catsOptions[0] && (
            <SelectCol
              sm={4}
              name="catLevel1"
              errors={errors}
              register={register}
              onChange={tryUpdateCategory}
              options={catsOptions[0]}
              label="מחלקה"
              value={watch("catLevel1")}
              clearable={false}
            />
          )}
        </Row>

        <Row>
          <InputCol
            sm={2}
            name="weightDetails.netContent"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="משקל"
          />
          <SelectCol
            sm={2}
            name="weightDetails.unitOfMeasure"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={unitOfMeasureOptions}
            label="יח׳ משקל"
            value={watch("weightDetails.unitOfMeasure")}
          />
          <SelectCol
            sm={4}
            name="kosherSupervision[0].kashrutFeature"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={kashrutFeatureOptions}
            label="סוג כשרות"
            value={watch("kosherSupervision[0].kashrutFeature")}
          />
          {catsOptions[1]?.length && (
            <SelectCol
              sm={4}
              name="catLevel2"
              errors={errors}
              onChange={tryUpdateCategory}
              register={register}
              options={catsOptions[1]}
              label="קבוצה"
              value={watch("catLevel2")}
            />
          )}
        </Row>

        <Row>
          <InputCol
            sm={2}
            name="weightJump"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="קפיצת משקל"
          />
          <InputCol
            sm={2}
            name="weightDetails.grossWeight"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="סטיית משקל ברוטו"
          />
          <SelectCol
            sm={4}
            name="kosherSupervision[0].classification"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={kashrutTypeOptions}
            label="חלבי / בשרי"
            value={watch("kosherSupervision[0].classification")}
          />
          {catsOptions[2]?.length > 0 && (
            <SelectCol
              sm={4}
              name="catLevel3"
              errors={errors}
              onChange={tryUpdateCategory}
              register={register}
              options={catsOptions[2]}
              label="תת קבוצה"
              value={watch("catLevel3")}
            />
          )}
        </Row>

        <Row>
          <Col sm={4}>
            <ProductEditPerloed
              label="מוצר מקביל"
              arrShow={parallelProds}
              onSelectProduct={(value) =>
                selectProductLink(product.Mkt, value, "2")
              }
              products={products}
              removeLinkage={(value) => removeLinkage(product.Mkt, value, "2")}
            />
          </Col>

          <SelectCol
            sm={4}
            name="subBrand"
            errors={errors}
            onChange={tryUpdate}
            register={register}
            options={subBrand}
            label="מותג"
            value={watch("subBrand")}
          />
          {catsOptions[3]?.length > 0 && (
            <SelectCol
              sm={4}
              name="catLevel4"
              errors={errors}
              onChange={tryUpdateCategory}
              register={register}
              options={catsOptions[3]}
              label="מקבץ"
              value={watch("catLevel4")}
            />
          )}
        </Row>

        <Row>
          <Col sm={4}>
            <ProductEditPerloed
              label="מוצר חלופי"
              arrShow={alterProds}
              onSelectProduct={(value) =>
                selectProductLink(product.Mkt, value, "1")
              }
              products={products}
              removeLinkage={(value) => removeLinkage(product.Mkt, value, "1")}
            />
          </Col>

          <InputCol
            sm={2}
            name="logisticsDetails.packageQuantity"
            errors={errors}
            onBlur={tryUpdate}
            register={register}
            type="text"
            label="כמות למארז"
          />
        </Row>

        <div className="check-box">
          <div className="checkbox-style">
            <Input
              name="vatExempt"
              errors={errors}
              onChange={tryUpdate}
              register={register}
              type="checkbox"
              label='פטור מע"מ'
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="SupervisedPrice"
              errors={errors}
              onChange={tryUpdate}
              register={register}
              type="checkbox"
              label="בפיקוח"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="weightDetails.weighedProduct"
              errors={errors}
              onChange={tryUpdate}
              register={register}
              type="checkbox"
              label="מוצר שקיל"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="DepositProduct"
              errors={errors}
              onChange={tryUpdate}
              register={register}
              type="checkbox"
              label="פריט פקדון"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="expiredManagement"
              errors={errors}
              onChange={tryUpdate}
              register={register}
              type="checkbox"
              label="ניהול תוקף"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="ShowExpired"
              errors={errors}
              onChange={tryUpdate}
              register={register}
              type="checkbox"
              label="הצג תוקף"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="viewBrand"
              errors={errors}
              onChange={tryUpdate}
              register={register}
              type="checkbox"
              label="הצג מותג"
            />
          </div>
          <div className="checkbox-style">
            <Input
              name="showOutOfStock"
              errors={errors}
              onChange={tryUpdate}
              register={register}
              type="checkbox"
              label="העלמת תמונה"
            />
          </div>
        </div>
        {/* {product.Category.length && product.Category[product.Category.length-1].isFamily && <> <p>כל המוצרים במקבץ זה:</p> <ul> {items.map((prod) => { return <li key={prod.Mkt}><a href={`/edit-product/${prod.Mkt}`}>{prod.ProductName}</a></li>; })}</ul></>} */}
      </Container>
    </form>
  );
};

const InputCol = ({ name, errors, label, type, register, sm, onBlur }) => {
  return (
    <Col sm={sm}>
      <Input
        name={name}
        errors={errors}
        onBlur={onBlur}
        register={register}
        label={label}
        type={type}
      />
    </Col>
  );
};

const SelectCol = ({
  name,
  errors,
  label,
  register,
  sm,
  options,
  onChange,
  value,
  clearable = true,
}) => {
  return (
    <Col sm={sm}>
      <Select
        name={name}
        errors={errors}
        {...register(name)}
        options={options}
        label={label}
        onChange={onChange}
        value={value}
        clearable={clearable}
      />
    </Col>
  );
};

export default ProductEditForm;
